import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader.tsx";
import { lazy, Suspense } from "react";

const StepsHistoryPage = lazy(() => import("./StepsHistoryPage.tsx"));

function StepsHistoryPageLazy() {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <StepsHistoryPage />
    </Suspense>
  );
}

export default StepsHistoryPageLazy;
